<template>
  <div class="page-with-top-bar">
    <project-admin-quick-buttons hiddenOption="edit"/>

    <div class="flex items-center justify-end w-full">
      <v-button v-if="this.projectId" icon="list" @click="goToPage('kpi')" class="mr-4">{{ 'KPI' }}</v-button>
      <v-button v-if="this.projectId" icon="list" @click="goToPage('extrafields')" class="mr-4">{{ $t('extrafields') }}</v-button>
      <v-button v-if="this.projectId" icon="tasks" @click="goToPage('bulk-actions')" class="mr-4">{{ $t('bulk_actions') }}</v-button>
      <v-button v-if="this.projectId" icon="tasks-alt" @click="goToPage('visual-config')" class="mr-4">{{ $t('interface_configuration') }}</v-button>
    </div>

    <div class="panel">
      <div class="flex">
        <div class="w-full pb-2">
          <font class="font-bold rounded p-1" style="background-color:#f4f4f4;"># {{ projectId }}</font>
        </div>
      </div>
      <div class="flex">
        <!-- Nombre -->
        <div class="w-1/3 pr-4">
          <l-form-input
            ref="projectName"
            :form="form"
            field="name"
            label="project_name"
            placeholder="project_name_placeholder"
          />
        </div>
        <!-- Referencia -->
        <div class="w-1/3 pr-4">
          <l-form-input
            :form="form"
            field="reference"
            label="project_reference"
            placeholder="project_reference_placeholder"
            :maxlength="45"
          />
        </div>
        <!-- Área al que pertenece el proyecto -->
        <div class="w-1/3">
          <l-form-select
            :form="form"
            field="area_id"
            :options="areas"
            label="area"
            icon="sitemap"
            full
            @input="addManagers"
          />
        </div>
      </div>
      <!-- Fechas -->
      <div class="flex mt-8">
        <div class="w-1/3 mr-4">
          <l-form-double-date
            :form="form"
            startField="raw_scheduled_start_date"
            endField="raw_scheduled_end_date"
            label="scheduled_date"
          />
        </div>
        <div class="w-1/3 mr-4">
          <l-form-double-date
            :form="form"
            startField="raw_current_start_date"
            endField="raw_current_end_date"
            label="estimated_date"
            :disabled="this.createNew"
          />
        </div>
        <div class="w-1/3">
          <l-form-double-date
            :form="form"
            startField="raw_real_start_date"
            endField="raw_real_end_date"
            label="real_date"
            :disabled="this.createNew"
          />
        </div>
      </div>
      <!-- Descripción -->
      <div class="flex items-center mt-8 mb-3">
        <div class="w-full">
          <label for="description" class="label">{{ $t('project_description') }}</label>
          <quill-editor
            v-model="form.description"
            :options="editorOption"
            class="w-full"
          />
        </div>
      </div>
      <!-- Imagen del proyecto -->
      <div class="w-2/3 pr-4">
        <b-field class="file is-primary" :class="{'has-name': !!this.image}" v-if="!this.createNew" >
          <div class="w-1/2 pr-4">
            <label class="label">{{$t('project_image')}}</label>
            <img :src="this.image" class="w-full" v-if="this.image" style="box-shadow: 1px 1px 3px #d5d5d5">
            <div v-else><scale-loader></scale-loader></div>
          </div>
          <div class="w-1/2 pr-4">
            <label class="label">{{$t('change_image')}}</label>
            <b-upload  class="file-label" @input="uploadImage">
              <span class="file-cta">
                <b-icon class="file-icon" icon="upload" pack="fas"></b-icon>
                <span class="file-label">{{$t('upload_image')}}</span>
              </span>
            </b-upload>
          </div>
        </b-field>
      </div>
      <!-- Mapa de Regiones DEPRECATED -->
      <!-- <div class="mb-8" v-if="!isLoading">
        <label class="label">{{$t('regions')}}</label>
        <g-map-markers-loader ref="regionsMap" :mapConfig="mapConfig" :points="points"/>
      </div> -->

      <!-- Gestión de almacenes -->
      <div class="flex">
        <div class="w-1/3">
          <b-field :label="$t('project_has_warehouse_title')">
            <b-switch
              v-model="form.hasWarehouse"
              :disabled="true"
            >{{ $t(form.hasWarehouse ? 'yes' : 'no') }}
            </b-switch>
          </b-field>

          <b-field :label="$t('storehouse_type')">
            <b-select :placeholder="$t('select')" v-model="form.warehouse_type" expanded>
              <option v-for="item in warehouseTypes" :value="item.id" :key="'wh_type_' + item.id">
                {{ $t(item.name) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <!-- Presupuesto -->
        <div class="w-1/3">
          <l-form-input
            :form="form"
            field="budget"
            label="budget"
            placeholder="budget_placeholder"
          />
        </div>
        <div class="w-1/3">
          <b-field :label="$t('select_currency')">
            <b-select :placeholder="$t('select_currency')" v-model="form.currency" required>
              <option value="€">€ - Euro</option>
              <option value="£">£ - Libra</option>
              <option value="$">$ - Dólar</option>
              <option value="C$">C$ - Dólar Canadiense</option>
              <option value="CHF">CHF - Franco Suizo</option>
              <option value="kr">kr - Corona Sueca</option>
              <option value="R$">R$ - Real Brasileño</option>
            </b-select>
          </b-field>
        </div>

        <!-- tipo de incidencia -->
        <div class="w-1/3">
          <b-field :label="$t('issue_type')">
            <b-select :placeholder="$t('select')" v-model="form.issue_template" required>
              <option v-for="item in issueTemplate" :value="item.id" :key="item.id">{{ $t(item.name) }}</option>
            </b-select>
          </b-field>
        </div>
      </div>

      <!-- SHAREPOINT -->
      <div class="flex">
        <div class="w-full pr-4">
          <l-form-input
            ref="sharepointSite"
            :form="form"
            field="sharepoint_site"
            label="Sharepoint Site"
            placeholder="Sharepoint Site"
          />
        </div>
      </div>

      <div class="flex">
        <div class="w-1/3">
          <b-field :label="$t('gantt_type')">
            <b-switch
              v-model="form.is_gantt_inspected"
              passive-type="is-success"
            >{{ $t(form.is_gantt_inspected ? 'inspected' : 'actual') }}
            </b-switch>
          </b-field>
        </div>
        <!-- Doble check: las cantidades validadas por inspección deben validarse tambien por calidad -->
        <div class="w-1/3">
          <b-field :label="$t('quality_validation')">
            <b-switch
              v-model="form.has_quality_validation"
              type="is-success"
            >{{ $t(form.has_quality_validation ? 'yes' : 'no') }}
            </b-switch>
          </b-field>
        </div>
      </div>

      <!-- Exigir vínculo BOQ para registrar avance (por tipo de avance). Por defecto off. -->
      <div class="flex">
        <div class="w-1/3">
          <b-field :label="$t('require_boq_link_on_progress')">
            <b-switch
              v-model="form.require_boq_link_on_progress"
              type="is-success"
            >{{ $t(form.require_boq_link_on_progress ? 'yes' : 'no') }}
            </b-switch>
          </b-field>
        </div>
        <div class="w-1/3">
          <b-field :label="$t('require_boq_link_on_actual_progress')">
            <b-switch
              v-model="form.require_boq_link_on_actual_progress"
              type="is-success"
            >{{ $t(form.require_boq_link_on_actual_progress ? 'yes' : 'no') }}
            </b-switch>
          </b-field>
        </div>
      </div>

      <div class="panel">
        <span class="label">{{ $t('work_mode_configuration') }}</span>
        <div class="flex flex-wrap -mx-2 mt-2">
          <div class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 min-w-0">
            <b-field :label="$t('project_progress_type')">
              <b-select
                v-model="form.progress_type"
                :placeholder="$t('not_configured')"
                expanded
              >
                <option :value="''">{{ $t('not_configured') }}</option>
                <option value="standard">{{ $t('standard') }}</option>
                <option value="weekly">{{ $t('progress_type_weekly') }}</option>
              </b-select>
            </b-field>
          </div>
          <div v-if="showBoqRootConfig" class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 min-w-0">
            <b-field :label="$t('project_boq_root_mode')">
              <b-select
                v-model="form.boq_root"
                :placeholder="$t('not_configured')"
                expanded
              >
                <option :value="''">{{ $t('not_configured') }}</option>
                <option value="root">{{ $t('boq_root_mode_root') }}</option>
                <option value="linked">{{ $t('boq_root_mode_linked') }}</option>
                <option value="free">{{ $t('boq_root_mode_free') }}</option>
              </b-select>
            </b-field>
          </div>
          <div v-if="showProgressTypeMode" class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 min-w-0">
            <b-field :label="$t('project_progress_type_mode')">
              <b-select
                v-model="form.progress_type_mode"
                :placeholder="$t('not_configured')"
                expanded
              >
                <option :value="''">{{ $t('not_configured') }}</option>
                <option value="activity">{{ $t('activity') }}</option>
                <option value="subactivity">{{ $t('subactivity') }}</option>
                <option value="takeoff">{{ $t('takeoff') }}</option>
              </b-select>
            </b-field>
          </div>
          <div v-if="showManHour" class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 min-w-0">
            <b-field :label="$t('project_man_hour')">
              <b-numberinput
                v-model="form.man_hour"
                :min="0"
                :step="0.5"
                controls-position="compact"
                expanded
                icon-pack="fas"
              />
            </b-field>
          </div>
          <p v-if="form.boq_root === 'free'" class="w-full px-2 text-sm text-gray-600">
            <b-icon icon="info-circle" pack="fas" size="is-small" type="is-info"></b-icon>
            {{ $t('boq_root_mode_free_help') }}
          </p>
        </div>
      </div>

      <div class="panel">
        <span class="label">{{ $t('quantity_display_decimals') }}</span>
        <div class="flex flex-wrap -mx-2 mt-2">
          <div class="w-full sm:w-1/2 lg:w-1/4 px-2 mb-4 min-w-0">
            <b-field>
              <b-select
                v-model="form.quantity_display_decimals"
                expanded
              >
                <option :value="2">{{ $t('quantity_display_decimals_2') }}</option>
                <option :value="4">{{ $t('quantity_display_decimals_4') }}</option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>

      <div class="w-full items-center mt-8">
        <span class="label">{{ $t('project_tags') }}</span>
        <model-tags
          :model-id="projectId ? projectId : 0"
          model-type="project"
          :allow-edit="false"
          :hooks-enabled="! createNew"
          ref="model_tags"
        />
      </div>
      <!-- Usuarios -->
      <div class="flex mt-8">
        <!-- Jefes de proyecto -->
        <userlist
          ref="managers"
          title="project_managers"
          icon="cog"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          :api-url="apiUrl"
          :users-permission-type="['admin']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          :allow-zero-users="false"
          :only-internal-users="true"
          class="w-1/2 pr-3"
          roleName="project_admin"
        />
        <!-- Visualizadores -->
        <userlist
          ref="viewers"
          title="viewers_users"
          icon="eye"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          :api-url="apiUrl"
          :users-permission-type="['view']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          @user-added="viewerAdded($event)"
          :allow-zero-users="true"
          :only-internal-users="true"
          class="w-1/2 pl-3"
          roleName="viewer"
        />
      </div>
      <div class="flex mt-8">
        <!-- Usuarios del proyecto -->
        <userlist
          ref="participants"
          title="project_users"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="users"
          :api-url="apiUrl"
          :users-permission-type="['participate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          @user-added="participantAdded($event)"
          :allow-zero-users="true"
          :only-internal-users="true"
          class="w-full md:w-1/2 pr-3"
          roleName="participant"
        />
        <!-- Colaboradores -->
        <userlist
          ref="collaborators"
          title="collaborator_users"
          icon="address-book"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          :api-url="apiUrl"
          :users-permission-type="['collaborate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          :allow-zero-users="true"
          :allow-external-users="true"
          :only-external-users="true"
          :is-project="parseInt(projectId)"
          class="w-full md:w-1/2 pl-3"
          roleName="collaborator"
        />
      </div>
      <div class="flex mt-8">
        <!-- Certificadores de mediciones -->
        <userlist
          ref="certifiers"
          title="certifiers_users"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="thumbs-up"
          :api-url="apiUrl"
          :users-permission-type="['certificate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="certifier"
          />

        <!-- flow_certifier -->
        <userlist
          ref="flow_certifier"
          title="flow_certifier_users"
          icon="address-book"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          :api-url="apiUrl"
          :users-permission-type="['collaborate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          :allow-zero-users="true"
          :allow-external-users="true"
          :only-external-users="true"
          :is-project="parseInt(projectId)"
          class="w-full md:w-1/2 pl-3"
          roleName="flow_certifier"
        />
      </div>

      <div class="flex mt-8">
        <!-- Visualizadores only actividad -->
        <userlist
          ref="activity_viewers"
          title="viewers_users_activities_only"
          icon="eye"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          :api-url="apiUrl"
          :users-permission-type="['view']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          @user-added="activityViewerAdded($event)"
          :allow-zero-users="true"
          :only-internal-users="true"
          class="w-1/2 pl-3"
          roleName="activity_viewer"
        />
        <!-- Participantes de flujos de validaciones -->
        <userlist
          ref="validation_users"
          title="validation_users"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="project-diagram"
          :api-url="apiUrl"
          :users-permission-type="['participate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="validation_user"
        />
      </div>

      <div v-if="form.has_quality_validation" class="flex mt-8">
        <!-- Validadores de calidad (doble check de cantidades validadas por inspección) -->
        <userlist
          ref="quality_validators"
          title="quality_validators_users"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="clipboard-check"
          :api-url="apiUrl"
          :users-permission-type="['participate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="quality_validator"
        />
      </div>

      <div class="flex mt-8">
        <!-- Participantes de incidencias -->
        <userlist
          ref="issues"
          title="issues_users"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="exclamation-triangle"
          :api-url="apiUrl"
          :users-permission-type="['participate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="issue_user"
        />
      </div>
      <div v-if="form.issue_template == 1" class="flex mt-8">
        <!-- responsables de incidencias -->
        <userlist
          ref="issue_admin"
          title="issue_managers"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="exclamation-triangle"
          :api-url="apiUrl"
          :users-permission-type="['issue_admin']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="issue_admin"
        />

        <!-- responsable de resolución de incidencias -->
        <userlist
          ref="issue_resolutor"
          title="issue_resolutor"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="exclamation-triangle"
          :api-url="apiUrl"
          :users-permission-type="['issue_resolutor']"
          :allow-create-users="!createNew"
          :local-mode="createNew"
          :allow-zero-users="true"
          :allow-external-users="true"
          :only-external-users="true"
          class="w-full md:w-1/2 pr-3"
          roleName="issue_resolutor"
        />
      </div>

      <div class="flex mt-8">
        <!-- Auditor de progreso (registra actual progress) -->
        <userlist
          ref="progress"
          title="progress_users"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="chart-line"
          :api-url="apiUrl"
          :users-permission-type="['participate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="progress_user"
        />

        <!-- Usuario gestor de documentos (sharepoint) -->
        <userlist
          ref="document_manager"
          title="document_manager"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="file"
          :api-url="apiUrl"
          :users-permission-type="['participate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="document_manager"
        />
      </div>
      <div class="flex mt-8">
        <!-- Responsables de almacén -->
        <userlist
          ref="warehouse_managers"
          title="warehouse_managers"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="store-alt"
          :api-url="apiUrl"
          :users-permission-type="['participate']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="warehouse_manager"
        />
      </div>
      <div class="flex mt-8" v-if="hasSubtasksConfig">
        <!-- Usuario task_resolutor -->
        <userlist
          ref="task_resolutor"
          title="task_resolutor_title"
          :parent-entity-id="createNew ? null : parseInt(projectId)"
          icon="exclamation-triangle"
          :api-url="apiUrl"
          :users-permission-type="['task_resolutor']"
          :allow-create-users="!createNew"
          :local-mode="createNew"

          :allow-zero-users="true"
          :only-internal-users="false"
          class="w-full md:w-1/2 pr-3"
          roleName="task_resolutor"
        />
      </div>

    </div>
    <form
      @submit.prevent="sendProjectData"
      @keydown="form.onKeydown($event)"
      class="w-full flex items-center justify-end mb-8"
    >
      <v-button :disabled="disableSaveButton" type="submit" icon="thumbs-up" icon-pack="far" class="mr-4">Guardar</v-button>
      <v-button color="grey" icon="undo-alt" @click="$router.go(-1)">Cancelar</v-button>
    </form>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from "axios";
  import api from "~/api";
  import Form from "vform";
  import Userlist from "~/components/UserBox/UserList.vue";
  import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
  import moment from "moment";
  import ModelTags from "../../components/model-tags";
  import GMapMarkersLoader from "~/components/Map/GMapMarkersLoader";
  import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
  import { quillEditor } from "vue-quill-editor";
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  import "quill/dist/quill.bubble.css";

  export default {
    middleware: "auth",
    title: "project_edit_page_title",
    subtitle: "project_edit_page_subtitle",
    menuOption: "0-2",

    components: {
      GMapMarkersLoader,
      ModelTags,
      Userlist,
      ProjectAdminQuickButtons,
      ScaleLoader,
      quillEditor,
    },

    data: () => ({
      isLoading: true,
      projectId: null,
      createNew: false,
      center: {lat: 36.68631, lng: -6.14958},
      points: [],
      issueTemplate:[
        {id: 0, name: "standard"},
        {id: 1, name: "advanced"}
      ],
      warehouseTypes: [
        { id: 0, name: 'storehouse_classic' },
        { id: 1, name: 'storehouse_v2' },
      ],
      image: '',
      form: new Form({
        area_id: null,
        budget: null,
        issue_template: 0,
        warehouse_type: 0,
        currency: "€",
        name: "",
        hasWarehouse: false,
        is_gantt_inspected: false,
        has_quality_validation: false,
        require_boq_link_on_progress: false,
        require_boq_link_on_actual_progress: false,
        progress_type: '',
        boq_root: '',
        progress_type_mode: '',
        man_hour: null,
        quantity_display_decimals: 2,
        reference: "",
        organization_chart_type: 0,
        scheduled_start_date: null,
        scheduled_end_date: null,
        current_start_date: null,
        current_end_date: null,
        real_start_date: null,
        real_end_date: null,
        raw_scheduled_start_date: null,
        raw_scheduled_end_date: null,
        raw_current_start_date: null,
        raw_current_end_date: null,
        raw_real_start_date: null,
        raw_real_end_date: null,
        description: "",
        sharepoint_site: "",
        create_location_in_activity: false,
        has_daily_report_module: false,
        has_planning_module: false,
        add_company_users: false,
        managers: null,
        viewers: null,
        participants: null,
        collaborators: null,
        issue_admin: null,
        issue_resolutor: null,
        task_resolutor: null,
        regions: []
      }),
      organizationCharTypes: [
        {id: 0, name: "oct_strict"}
        //17-07-2018 Sólo habilitamos el organigrama rígido
      ],
      areas: [],
      apiUrl: "/api/v2/project",
      scheduled_start_date: null,
      scheduled_end_date: null,
      current_start_date: null,
      current_end_date: null,
      real_start_date: null,
      real_end_date: null,
      disableSaveButton: false,
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ align: [] }],
            ['link', 'image'], 
            ['clean']
          ],
          'emoji-toolbar': true,
          'emoji-textarea': false,
          'emoji-shortname': true
        }
      }
    }),

    computed: {
      ...mapGetters({
        user: "auth/userBasicInfo",
        navData: "app/navData",
        project: "app/project",
        company: "app/company"
      }),

      mapConfig() {
        return {
          center: this.mapCenter,
          zoom: 19
        };
      },

      mapCenter() {
        return this.center
      },

      hasSubtasksConfig() {
        return !!(this.company && this.company.configs && this.company.configs.subtasks)
      },

      showBoqRootConfig() {
        // configuracion para que el trabajo de actividades y mediciones se haga por semanas
        // ademas de que la creacion de mediciones solo de podra hacer partiendo de la tabla boq_root
        // no se podra crear mediciones manuales dentro de la actividad
        return this.form.progress_type === 'weekly'
      },

      showProgressTypeMode() {
        // actividad, subactividad y takeoff solo aplican a raíz y vinculado
        return this.form.boq_root === 'root' || this.form.boq_root === 'linked'
      },

      showManHour() {
        return this.form.progress_type_mode === 'activity'
          || this.form.progress_type_mode === 'subactivity'
      },
    },

    watch: {
      'form.progress_type'(value) {
        if (value !== 'weekly') {
          this.form.boq_root = ''
          this.form.progress_type_mode = ''
          this.form.man_hour = null
        }
      },
      'form.boq_root'(value) {
        if (value !== 'root' && value !== 'linked') {
          this.form.progress_type_mode = ''
        }
      },
      'form.progress_type_mode'(value) {
        if (value !== 'activity' && value !== 'subactivity') {
          this.form.man_hour = null
        }
      },
    },

    created() {
      // Datos del área padre
      this.form.hasWarehouse = false;
      this.form.area_id = this.$route.params.area_id;
      this.$options.subtitle = [
        "project_page_subtitle",
        [this.navData.area_name.toUpperCase()]
      ];
      // Cargamos los áreas existentes
      this.loadAreas();
      // Crear nuevo proyecto
      if (this.$route.name === "project.create") {
        this.createNew = true;
        this.$options.title = "project_create_page_title";
      } else {
        this.projectId = parseInt(this.$route.params.project_id);
      }
    },

    mounted() {
      if (this.projectId) {
        this.getProjectData();
      }
      else
        this.isLoading = false;
    },

    methods: {
      syncSelectedProjectDisplayDecimals() {
        if (this.createNew || !this.project || Number(this.project.id) !== Number(this.projectId)) {
          return
        }

        const decimals = Number(this.form.quantity_display_decimals) === 4 ? 4 : 2
        this.$store.dispatch('app/setProject', {
          project: {
            ...this.project,
            configs: {
              ...(this.project.configs || {}),
              quantity_display_decimals: decimals,
            },
          },
        })
      },

      async sendProjectData() {
        this.disableButton();

        // Añadimos listas de usuarios
        this.form.managers = this.$refs.managers.getUsersIds();
        this.form.viewers = this.$refs.viewers.getUsersIds();
        this.form.participants = this.$refs.participants.getUsersIds();
        this.form.collaborators = this.$refs.collaborators.getUsersIds();
        this.form.warehouse_managers = this.$refs.warehouse_managers.getUsersIds();
        if (this.form.issue_template == 1) {
          this.form.issue_admin = this.$refs.issue_admin.getUsersIds();
          this.form.issue_resolutor = this.$refs.issue_resolutor.getUsersIds();
        }

        if (this.hasSubtasksConfig) {
          this.form.task_resolutor = this.$refs.task_resolutor.getUsersIds();
        }

        //Tratamos las fechas del form con moment para evitar problemas de zonas horarias
        this.form.scheduled_start_date = moment(
          this.form.raw_scheduled_start_date
        ).format("YYYY-MM-DD");
        this.form.scheduled_end_date = moment(
          this.form.raw_scheduled_end_date
        ).format("YYYY-MM-DD");
        this.form.current_start_date = moment(
          this.form.raw_current_start_date
        ).format("YYYY-MM-DD");
        this.form.current_end_date = moment(
          this.form.raw_current_end_date
        ).format("YYYY-MM-DD");
        this.form.real_start_date = moment(this.form.raw_real_start_date).format(
          "YYYY-MM-DD"
        );
        this.form.real_end_date = moment(this.form.raw_real_end_date).format(
          "YYYY-MM-DD"
        );

        // Edit
        var url = this.apiUrl;
        if (!this.createNew) {
          url += "/" + this.projectId;
        }
        // Enviamos el form
        const {data} = await this.form.post(url);

        if (data && data.success) {
          this.projectId = this.projectId ? this.projectId : data.project_id;

          // Añadimos las etiquetas si estamos creando proyectos
          if (this.createNew) {
            this.$refs.model_tags.syncTagsToModel(this.projectId);
          }

          // La vista abierta lee el proyecto del store, no vuelve a pedirlo al guardar.
          this.syncSelectedProjectDisplayDecimals();

          // Success y nos vamos
          this.$notify.success(
            this.createNew
              ? "success_creating_project"
              : "success_editing_project"
          );
          
          if (this.createNew) {
            this.$router.push({ name: 'project.edit', params: { project_id: this.projectId } })
          } else {
            this.$router.push({ name: 'admin.projects' })
          }

        } else {
          this.$notify.error(
            this.createNew ? "error_creating_project" : "error_editing_project"
          );
        }
      },
      // Añadimos los managers al cambiar el área si estamos creando el proyecto
      addManagers() {
        if (this.createNew) {
          // Añadir los responsables del área como gestores de proyecto
          let self = this;
          api.fetchArea(this.form.area_id).then(function (value) {
            self.$refs.managers.usersList =
              value.managers.length > 0 ? value.managers : [self.user];
          });
        }
      },

      async getProjectData() {
        let params = {};
        const {data} = await axios.get("/api/v2/project/" + this.projectId, {params: params});
        if (data && this.$refs.model_tags) {
          this.$refs.model_tags.initTags(data.tags);
          this.form.area_id = data.area_id;
          this.form.budget = data.budget;
          this.form.currency = data.currency;
          this.form.name = data.name;
          this.form.reference = data.reference;
          this.form.description = data.description;
          this.form.organization_chart_type = data.organization_chart_type;
          this.form.issue_template = data.issue_template;
          this.form.warehouse_type = (data.warehouse_type != null) ? Number(data.warehouse_type) : 0;
          this.form.raw_scheduled_start_date = new Date(
            data.scheduled_start_date
          );
          this.form.raw_scheduled_end_date = new Date(data.scheduled_end_date);
          this.form.raw_current_start_date = new Date(data.current_start_date);
          this.form.raw_current_end_date = new Date(data.current_end_date);
          this.form.raw_real_start_date = new Date(data.real_start_date);
          this.form.raw_real_end_date = new Date(data.real_end_date);
          this.form.create_location_in_activity =
            data.create_location_in_activity === 1;
          this.form.has_daily_report_module = data.has_daily_report_module === 1;
          this.form.has_planning_module = data.has_planning_module === 1;
          this.form.add_company_users = data.add_company_users === 1;
          this.image = data.image;
          this.form.sharepoint_site = data.sharepoint_site;
          this.form.is_gantt_inspected = data.is_gantt_inspected == 1;
          this.form.has_quality_validation = !!data.has_quality_validation;
          this.form.require_boq_link_on_progress = !!data.require_boq_link_on_progress;
          this.form.require_boq_link_on_actual_progress = !!data.require_boq_link_on_actual_progress;

          const configs = data.configs || {}
          this.form.progress_type = configs.progress_type || ''
          this.form.boq_root = configs.boq_root || ''
          this.form.progress_type_mode = configs.progress_type_mode || ''
          this.form.man_hour = configs.man_hour != null && configs.man_hour !== '' ? Number(configs.man_hour) : null
          this.form.quantity_display_decimals = Number(configs.quantity_display_decimals) === 4 ? 4 : 2
        } else {
          this.$notify.error("error_loading_project_data");
        }

        this.isLoading = false;
      },

      async viewerAdded(user) {
        //Comprobamos que no está ni como participante
        if (this.isUserInList(user, this.$refs.participants)) {
          this.removeUserFromList(user, this.$refs.viewers, ["viewer"]);
          this.$notify.error("error_user_in_use_project_participant");
        }
      },

      async participantAdded(user) {
        //Comprobamos que no está ni como visualizador
        if (this.isUserInList(user, this.$refs.viewers)) {
          this.removeUserFromList(user, this.$refs.participants, ["participate"]);
          this.$notify.error("error_user_in_use_project_viewer");
        }
      },

      async activityViewerAdded(user) {
        //Comprobamos que no está ni como visualizador
        if (this.isUserInList(user, this.$refs.viewers)) {
          // Si tiene el rol de visualizar se lo quitamos silenciosamente el rol
          this.removeUserFromList(user, this.$refs.viewers, ["viewer"]);
          // this.$notify.error("error_user_in_use_project_viewer");
        }

        // estas lineas a continuación comentamos ya que un usuario participante puede eatar tambien puede tener el rol de visualizador de activididad en un proyecto
        // pero no puede tener los dos dentro de una actividad

        //Comprobamos que no está ni como participante
        // if (this.isUserInList(user, this.$refs.participants)) {
        //   this.removeUserFromList(user, this.$refs.activity_viewers, ["activity_viewer"]);
        //   this.$notify.error("error_user_in_use_project_participant");
        // }

        //Comprobamos que no está ni como colaborador
        if (this.isUserInList(user, this.$refs.collaborators)) {
          this.removeUserFromList(user, this.$refs.activity_viewers, ["activity_viewer"]);
          this.$notify.error("error_user_in_use_project_collaborator");
        }
      },

      isUserInList(user, list) {
        var exist = false;
        for (var j = list.usersList.length - 1; j >= 0; j--) {
          if (list.usersList[j].user_id == user.user_id) {
            exist = true;
            break;
          }
        }
        return exist;
      },

      async removeUserFromList(user, list, permission) {
        for (var j = list.usersList.length - 1; j >= 0; j--) {
          if (list.usersList[j].user_id == user.user_id) {
            list.usersList.splice(j, 1);
            break;
          }
        }

        let url = "/api/v2/project/" + this.projectId + "/users/remove";
        const {data} = await axios.post(url, {
          user_id: user.user_id,
          // permission_type: permission // comento esta linea por que da problmeas ya que el parametro que recibe remove no es permission_type sino role_name
          role_name: permission[0] // mandamos el primer argumento
        });
      },

      loadAreas() {
        let self = this;
        api
          .fetchUserAreas({sort_field: "name", sort_dir: "asc"})
          .then(function (data) {
            if (data.areas.length > 0) {
              self.areas = data.areas.map(function (area) {
                return {
                  id: area.id,
                  name: area.name + " (" + area.reference_code + ")"
                };
              });
            }
          });
      },

      async uploadImage(file) {
        let url = "/api/v2/project/" + this.projectId + "/image";

        let self = this
        self.image=''; // reset image, show 'uploading...'

        const formData = new FormData();
        formData.append('image', file);

        await axios.post(url, formData)
          .then(function (response) {
            if (response.data.success && response.data.image) {
                self.image = response.data.image;
            }
            else
              console.log('Error uploading image',response);
          })
      },

      disableButton() {
        this.disableSaveButton = true
        let self = this
        setTimeout(function() {
          self.disableSaveButton = false
        }, 5000);
      },

      goToPage(destiny = 'extrafields') {

        switch (destiny) {
          case 'extrafields':
              this.$router.push({ name: 'project.extrafields.edit', params: {
                project_id: this.projectId
              } })
              break;
          case 'bulk-actions':
              this.$router.push({ name: 'project.admin.bulk-actions', params: {
                project_id: this.projectId
              } })
              break;
          case 'visual-config':
              this.$router.push({ name: 'project.admin.visual-config', params: {
                project_id: this.projectId
              } })
              break;
          case 'kpi':
              this.$router.push({ name: 'project.admin.kpi', params: {
                project_id: this.projectId
              } })
              break;
        }

      }
    }
  };
</script>